<div mat-dialog-content>
	<p class="dialog-message">
	 
	  {{'cart.limit_quantint_alert' | translate}}
	  ({{ data.data.max_per_period }}),
	  {{'cart.additional_quantity_be' | translate}}
	 
	  <span class="additional-price">{{ data.data.item_price }}</span>
	</p>
  </div>
  
  <div mat-dialog-actions class="ok">
	<button mat-button (click)="closeDialog()">{{'cart.ok' | translate}}</button>
  </div>
  